import https from "../init/https";

//QB-OBJ-01: Retrieve List of Objectives
export async function fetchObjective(taxonomy_id){
    const fetchObjectiveData = await https.get(`/objectives?taxonomy_id=${taxonomy_id}`);
    return fetchObjectiveData;
}